/**
 * Privacy Page Component
 * Displays the GDPR data protection and privacy policy for Clipstone Miners Welfare Trust,
 * detailing data collection, user rights, cookie usage, and contact policies.
 */

import React, { useEffect, useState } from 'react';
import { getSiteContent } from '../utils/siteContent';

const Privacy = () => {
  const [siteContent, setSiteContent] = useState(() => getSiteContent());

  useEffect(() => {
    const handleContentUpdate = () => setSiteContent(getSiteContent());
    window.addEventListener('site-content-updated', handleContentUpdate);
    return () => window.removeEventListener('site-content-updated', handleContentUpdate);
  }, []);

  return (
    <div className="content-page-container" style={styles.container}>
      <h1 id="privacy-page-heading" style={styles.title}>Privacy Policy</h1>
      <div style={styles.content}>
        <p>{siteContent.privacy.intro}</p>

        <h2 style={styles.sectionTitle}>Information we collect</h2>
        <ul style={styles.list}>
          {siteContent.privacy.collect.map((item) => <li key={item}>{item}</li>)}
        </ul>

        <h2 style={styles.sectionTitle}>How we use your information</h2>
        <ul style={styles.list}>
          {siteContent.privacy.use.map((item) => <li key={item}>{item}</li>)}
        </ul>

        <h2 style={styles.sectionTitle}>What we do not do</h2>
        <ul style={styles.list}>
          {siteContent.privacy.notDo.map((item) => <li key={item}>{item}</li>)}
        </ul>

        <h2 style={styles.sectionTitle}>Cookies and website tracking</h2>
        <p style={styles.paragraph}>{siteContent.privacy.cookies}</p>

        <h2 id="privacy-rights-section" style={styles.sectionTitle}>Your rights</h2>
        <ul style={styles.list}>
          {siteContent.privacy.rights.map((item) => <li key={item}>{item}</li>)}
        </ul>

        <h2 style={styles.sectionTitle}>Security</h2>
        <p style={styles.paragraph}>{siteContent.privacy.security}</p>

        <h2 style={styles.sectionTitle}>Changes to this policy</h2>
        <p style={styles.paragraph}>{siteContent.privacy.changes}</p>

        <h2 style={styles.sectionTitle}>Contact us</h2>
        <p style={styles.paragraph}>{siteContent.privacy.contact}</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '60px 20px',
    maxWidth: '900px',
    margin: '0 auto',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif'
  },
  title: {
    fontSize: '36px',
    color: '#1f2937',
    marginBottom: '24px',
    textAlign: 'center'
  },
  content: {
    fontSize: '18px',
    lineHeight: '1.8',
    color: '#4b5563'
  },
  sectionTitle: {
    marginTop: '28px',
    marginBottom: '14px',
    fontSize: '24px',
    color: '#0f4b2f'
  },
  list: {
    marginLeft: '1.1rem',
    marginBottom: '16px',
    paddingLeft: '18px'
  },
  paragraph: {
    marginTop: '16px',
    marginBottom: '16px'
  }
};

export default Privacy;
